import { isEqual } from 'lodash';

import { CampaignDto, CustomerDto } from '@shared/services/apiService/apiService';

import { CampaignFormCustomer, CreateCampaignFormValue } from '../model/type';
import { normalizeCampaignAnalysisPlan } from './analysis-plan';

export const mapCustomerDtoToFormCustomer = (customer: CustomerDto): CampaignFormCustomer => ({
  id: customer.id,
  number: customer.number,
  name: customer.name,
  gender: customer.gender,
  attributes: customer.attributes as Record<string, any> | undefined,
  metadata: customer.metadata as Record<string, any> | undefined,
  createdAt: customer.createdAt,
});

export const mapCampaignCustomersToFormCustomers = (
  customers?: CustomerDto[],
): CampaignFormCustomer[] | undefined => customers?.map(mapCustomerDtoToFormCustomer);

export const mapCampaignDtoToFormValues = (
  campaign: CampaignDto,
): Partial<CreateCampaignFormValue> => ({
  id: campaign.id || '',
  title: campaign.title || '',
  callSchedule: campaign.callSchedule,
  retryIntervalInMinutes: campaign.retryIntervalInMinutes || 0,
  retryMaxNumber: campaign.retryMaxNumber || 0,
  retriesPerDay: campaign.retriesPerDay || 0,
  analysisPlan: normalizeCampaignAnalysisPlan(campaign.analysisPlan),
  productDetails: campaign.productDetails,
  customers: mapCampaignCustomersToFormCustomers(campaign.customers),
  reservedLimit: campaign.reservedLimit,
  customerListChanged: false,
});

export const hasUnsavedCampaignChanges = (
  formData: CreateCampaignFormValue,
  campaignData: CampaignDto,
  leadListChanged: boolean,
) =>
  !isEqual(
    {
      title: formData.title,
      retryIntervalInMinutes: formData.retryIntervalInMinutes,
      retryMaxNumber: formData.retryMaxNumber,
      retriesPerDay: formData.retriesPerDay,
      callSchedule: formData.callSchedule,
      analysisPlan: normalizeCampaignAnalysisPlan(formData.analysisPlan),
      productDetails: formData.productDetails ?? null,
      reservedLimit: formData.reservedLimit,
      customers: leadListChanged
        ? formData.customers
        : mapCampaignCustomersToFormCustomers(campaignData.customers),
    },
    {
      title: campaignData.title ?? '',
      retryIntervalInMinutes: campaignData.retryIntervalInMinutes ?? 0,
      retryMaxNumber: campaignData.retryMaxNumber ?? 0,
      retriesPerDay: campaignData.retriesPerDay ?? 0,
      callSchedule: campaignData.callSchedule,
      analysisPlan: normalizeCampaignAnalysisPlan(campaignData.analysisPlan),
      productDetails: campaignData.productDetails ?? null,
      reservedLimit: campaignData.reservedLimit,
      customers: mapCampaignCustomersToFormCustomers(campaignData.customers),
    },
  );
